import React from 'react'

const ServiceCard = (props) => {
  return (
    <div className='flex w-full justify-start'>
      <div className='flex flex-col cursor-pointer border border-primaryBorder bg-[#07207c] rounded-lg max-w-md'>
          <div className='flex justify-center items-center w-full'>
            <img src={props.imageUrl} alt='service' className='w-full h-72 rounded-t-lg'/>
          </div>
          <div className='flex flex-col gap-4 px-4 py-8 bg-transparent'>
              <h1 className='font-extrabold text-2xl bg-transparent'>{props.technologyName}</h1>
              <h1 className='text-lg bg-transparent'>{props.description}</h1>
          </div>
      </div>
    </div>
  )
}

export default ServiceCard